import StepLearningGoalsController from './stepLearningGoalsController';
import './learningGoals.scss';

const StepLearningGoalsComponent = {
    template: require('./stepLearningGoalsView.html'),
    controller: StepLearningGoalsController
};

export default StepLearningGoalsComponent;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/pages/stepLearningGoals/stepLearningGoalsComponent.js